import { render, staticRenderFns } from "./inviteReg.vue?vue&type=template&id=6c1ef1bb&scoped=true&"
import script from "./inviteReg.vue?vue&type=script&lang=js&"
export * from "./inviteReg.vue?vue&type=script&lang=js&"
import style0 from "./inviteReg.vue?vue&type=style&index=0&id=6c1ef1bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ef1bb",
  null
  
)

export default component.exports